import styled from "styled-components";

const NotFoundStyleWrapper = styled.section`
  .notFoundArea{
    display:flex;
    justify-content:center;
    align-items:center;
    height:100vh;
  }

  .notFoundContent{
    text-align:center;
    h1{
      font-size: 200px;
      font-weight: 700;
      margin: 0;
      color: #FFF;
    }
    h2{
      font-size: 40px;
      font-weight: 500;
      margin: 0;
      color: #FFF;
    }
    p{
      font-size: 18px;
      color: #FFF;
      margin: 20px 0;
    }
    .back_btn{
     margin-left: auto;
     margin-right: auto;
    }
  }

  @media (max-width: 767px) {
    .notFoundContent{
      h1{
        font-size: 100px;
      }
      h2{
        font-size: 30px;
      }
      p{
       font-size: 16px;
      }
    }
  }

  @media (max-width: 575px) {
    .notFoundContent{
      h1{
        font-size: 80px;
      }
      h2{
        font-size: 25px;
      }
      p{
       font-size: 14px;
      }
  }
`;

export default NotFoundStyleWrapper;
